import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_COMP_PLAN_ACTION_TYPE } from '../actions/compPlan.actions';

const initialState = null;

const compPlanReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_COMP_PLAN_ACTION_TYPE.SET_COMP_PLAN:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default compPlanReducer;
